module.exports = "/static/assets/5a308bd1707070ac430b19a7d205ded0.png";